import type { Category } from '@opensentry/shared';
import { CATEGORY_ICON } from '../lib/icons.js';

export function CategoryIcon({ category, size = 14 }: { category: Category; size?: number }) {
  const Icon = CATEGORY_ICON[category];
  return <Icon size={size} aria-label={category} />;
}
